/**
 * @generated SignedSource<<02035ebd41369425f5a13662556ccf29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductInternalTools_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "ProductInternalTools_item";
};
export type ProductInternalTools_item$key = {
  readonly " $data"?: ProductInternalTools_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductInternalTools_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductInternalTools_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1ca0aec01f1fb2c63f37aa4086d5325b";

export default node;
